export default {
    BackendUrl: 'https://backend-development.talenyanetwork.com',
    ENVIRONMENT:          'development',
    NODE_ENV:             'development',
    WebAppUrl: 'https://development.webapp.talenyanetwork.com',
    inlinemanual:         true,
};
